<template>
    <div class="page--login">
        <div class="container">
            <div v-show="!isLoading">

                <hgroup class="login-title-group">
                    <h1>
                        <img
                            class="login-logo"
                            alt="Bubblelab"
                            width="151"
                            height="130"
                            src="@/assets/images/logos/logo-title-center.svg" />
                    </h1>
                </hgroup>

                <div class="grid desktop--horizontal--center">
                    <div class="grid__item desktop--4">
                        <form
                            class="page--login__form form"
                            action="#"
                            @submit.prevent="submitForm">

                            <div
                                class="field field--text">
                                <label
                                    class="field__label field--text__label"
                                    for="field-email">Email</label>
                                <input
                                    required
                                    name="email"
                                    data-label="Email"
                                    v-model="email"
                                    id="field-email"
                                    class="field__input field--text__input"
                                    type="email"
                                />

                                <p
                                    id="field-error-email"
                                    v-if="error.errors !== undefined && error.errors['email'] !== undefined && error.errors['email'].length > 0"
                                    class="field__message--error"
                                >
                                    {{ error.errors['email'][0] }}
                                </p>
                            </div>

                            <div
                                class="field field--text">
                                <label
                                    class="field__label field--text__label"
                                    for="field-password">Password</label>
                                <input
                                    required
                                    name="password"
                                    data-label="Password"
                                    v-model="password"
                                    id="field-password"
                                    class="field__input field--text__input"
                                    type="password"
                                />

                                <p
                                    id="field-error-password"
                                    v-if="error.errors !== undefined && error.errors['password'] !== undefined && error.errors['password'].length > 0"
                                    class="field__message--error"
                                >
                                    {{ error.errors['password'][0] }}
                                </p>
                            </div>

                            <div class="field">
                                <button class="button button--primary button--fullwidth">{{ $t("login") }}</button>
                            </div>

                            <p class="text-center">{{ $t("doesnt-have-an-account") }} <router-link to="/signup">{{ $t("signup-now") }}</router-link></p>

                            <p class="text-center"><router-link to="/forgot-password">{{ $t("i-forgot-my-password") }}</router-link></p>

                        </form>
                    </div>
                </div>
            </div>
            <div v-if="isLoading">
                <HorizontalBubbleLoader />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";

import { login, getUserInfo, getMe } from "@/utils/api/usersApi.js";
import { purify } from "@/utils/helpers/string.js";
import { setCookie } from "@/utils/helpers/cookie";
import { validateForm } from "@/utils/helpers/validate-form.js";


export default {
    name: "Login",
    components: {
        HorizontalBubbleLoader
    },
    data() {
        return {
            isLoading: false,
            email: "",
            password: "",
            error: "",
        };
    },
    computed: {
        user() {
            return {
                email: this.email,
                password: this.password,
            };
        },
        userPersonality() {
            return this.$store.getters["userModule/getPersonality"];
        }
    },
    mounted: function() {
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    methods: {
        submitForm() {
            const isFormValid = validateForm(this.$el);

            if(isFormValid.value === true) {


                login(this.user).then((res) => {

                    this.isLoading = true;

                    if (res.data && res.data.status === "ok") {
                        // console.log("user login", res.data);
                        
                        const loginInfo = {
                            "id": res.data.id,
                            "token": res.data.token
                        };

                        getUserInfo(loginInfo).then((res) => {
                            if (res.status === 200 && res.data) {

                                const userInfo = res.data;

                                if (!this.userPersonality) {
                                    getMe(loginInfo).then((res) => {
                                        if (res.status === 200 && res.data) {
                                            localStorage.setItem("user-token", loginInfo.token);
                                            localStorage.setItem("user-info", JSON.stringify(userInfo));
                                            this.$store.commit("userModule/setUser", userInfo);
                                            this.$store.commit("userModule/setToken", loginInfo.token);

                                            this.$store.commit("userModule/setPersonality", res.data);
                                            this.$router.push("/dashboard");


                                            // Temporary save JWT token in a cookie
                                            // WARNING: That's not secure at all, and we will update that with a proper persistent JWT strategy further
                                            let isCookieSecure = true;
                                            if (process.env.VUE_APP_ENVIRONMENT_NAME === "local") {
                                                isCookieSecure = false;
                                                setCookie("jwt_token", loginInfo.token, {"path": "/", "domain": process.env.VUE_APP_ROOT_URL, "httponly": false, "expires": 525600, "samesite": "Strict", "secure": isCookieSecure});
                                            }


                                        } else {
                                            localStorage.removeItem("user-token");
                                            localStorage.removeItem("user-info");
                                            // Handle Error
                                            let message = this.$t("a-server-error-occured-please-try-later");
                                            this.$notificationsBar.alert(message, {type: "warning"});
                                        }
                                    });
                                }

                            } else {
                                // Handle Error
                                let message = this.$t("a-server-error-occured-please-try-later");
                                this.$notificationsBar.alert(message, {type: "warning"});
                            }
                        });

                    } else {
                        this.isLoading = false;
                        // Handle Error
                        let message = this.$t("a-server-error-occured-please-try-later");

                        switch (res.status) {
                        case 401:
                            message = this.$t("wrong-username-password");
                            break;
                        }

                        this.$notificationsBar.alert(message, {type: "warning"});
                    }
                });
            } else {
                // There are some errors
                this.error = isFormValid.error;

                //Set focus to first error field for screen reader
                if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                    let errorFieldName = Object.keys(this.error.errors)[0];
                    let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                    if(errorField) {
                        errorField.focus();
                    }
                }
            }
        }
    }
};
</script>

